export enum DoctorTypeEnum {
  ValidValue  = 'F213FA7A-EB78-4E23-9BBF-F02C99D7BF0F',
  PROVIDER        = '00000004-1000-0000-0000-000000000001',
  REFERRALFROM      = '00000004-1000-0000-0000-000000000002',
  DEFAULTFEE = '00000004-1000-0000-0000-000000000003',
  REFERRALTO = '00000004-1000-0000-0000-000000000004',
  REFERRALBOTH = '00000004-1000-0000-0000-000000000005',
}
